import { PlayerAvatar } from '@/components/atoms/PlayerAvatar';
import { getProfileImageUrl } from '@/utils/utils';

interface PlayerDetailsProfileImageProps {
	url?: string;
	isHeaderImageAvailable: boolean;
	name: string;
}

export const PlayerDetailsProfileImage = (props: PlayerDetailsProfileImageProps) => {
	return (
		<div>
			{!props.isHeaderImageAvailable ? (
				<div className="mt-6 md:mt-0 pb-3 md:pb-0 flex items-end justify-center h-full border-b-2 border-b-[#EF6820] md:border-none">
					<PlayerAvatar
						name={props.name ?? undefined}
						src={props.url ? getProfileImageUrl(props.url, 500, 500) : undefined}
						className="size-[200px] md:size-[260px] lg:size-[320px] border-2 border-[#EF6820] rounded-full overflow-hidden"
						textClassName="text-8xl bg-gray-50 text-gray-500"
					/>
				</div>
			) : (
				<div className="mt-6 md:mt-0 flex items-end justify-center h-[260px] md:h-[420px] border-b-2 border-b-[#EF6820] md:border-none">
					<div className="flex items-end justify-center h-[240px] md:h-full  xl:h-[400px] w-full">
						<img
							src={getProfileImageUrl(props.url, 500, 500)}
							alt="Player img"
							className="object-contain max-h-full w-auto md:min-w-52"
						/>
					</div>
				</div>
			)}
		</div>
	);
};
